import * as Sentry from "@sentry/browser";
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    //Public key is given in Nginx conf. Something must still be defined for logging to work
    dsn: "http://0@192.168.10.65:8000/3",
    environment: process.env.NODE_ENV,
    sendDefaultPii: true,
    tunnel: '/tunnel',
  });
}
